import { render } from "./CreateGuestAssessment.vue?vue&type=template&id=e9a9532e&scoped=true"
import script from "./CreateGuestAssessment.vue?vue&type=script&lang=js"
export * from "./CreateGuestAssessment.vue?vue&type=script&lang=js"

import "./CreateGuestAssessment.vue?vue&type=style&index=0&id=e9a9532e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9a9532e"]])

export default __exports__